import ActionTypes from '../constants/ActionTypes';
import { lectio } from '../api';

export const fetchStates = () => async (dispatch, getState) => {
  if (getState().states.list.length > 0) return;

  try {
    const { data } = await lectio.get(`/location/states`);
    return dispatch({
      type: ActionTypes.FETCH_STATES_SUCCESS,
      payload: data
    });
  } catch (error) {
    return dispatch({
      type: ActionTypes.FETCH_STATES_ERROR,
      payload: [],
      error
    });
  }
};
